import { render, staticRenderFns } from "./RegAsDistToExamForm.vue?vue&type=template&id=2c7a5c4b&scoped=true&"
import script from "./RegAsDistToExamForm.vue?vue&type=script&lang=js&"
export * from "./RegAsDistToExamForm.vue?vue&type=script&lang=js&"
import style0 from "./RegAsDistToExamForm.vue?vue&type=style&index=0&id=2c7a5c4b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7a5c4b",
  null
  
)

export default component.exports